/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of announcement.
 */
export enum AnnouncementType {
  BANNER = 'banner',
  POP_UP = 'pop_up',
}
